import React, { useEffect, useRef, useState } from 'react'
import './my-xp-earnings-list.styles.scss';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { format } from 'date-fns';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { Route, Routes, useNavigate } from 'react-router-dom';
import PlayerNameIcon from '../player-name-icon.component';
import { getActivityRecordsQuery, getGameActivityFromDb } from '@/utils/getDataFromDb';
import TransactionView from '@/components/SHARED/tranaction-view/transaction-view.component';
import PlayerEarningsList from '../player-earnings-list.component';

const MyXpEarningsList = ({ 
    gameData,
    playerData, 
    gameElements 
}) => {
    
    const [ loading, setLoading ] = useState(true);
    const [ activityToDisplay, setActivityToDisplay ] = useState({});
    const [ moreCount, setMoreCount ] = useState(1);
    const [ moreLimit, setMoreLimit ] = useState(8);
    const [ noMore, setNoMore ] = useState(false);
    const activityRef = useRef({});
    const navigate = useNavigate();
    
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 3000)

        return () => {
            if (timer) clearTimeout(timer);
        }
    }, [])

    useEffect(() => {
        if (!playerData || !gameElements) return;
        // getXpEarningsList();
    }, [playerData, gameElements])

    function getXpEarningsList(next) {    
        const queryFilter = [
            {
                'key': 'playerId',
                'value': playerData.playerId
            },
            {
                'key': 'elementId',
                'value': 'points'
            },
            {
                'key': 'gameId',
                'value': playerData.gameId
            },
        ]
        if (next) {
            const len = Object.keys(activityRef.current).length;
            queryObject.lastEntry = Object.values(activityRef.current)
            .sort((a, b) => a.ts < b.ts ? 1 : -1)[len - 1];
        }
        const queryObject = {
            'gameId': playerData.gameId,
            'path': 'activityRecords',
            'filter': queryFilter,
            'limit': moreLimit,
            'once': true,
            'callback': callback
        }    
        getActivityRecordsQuery(queryObject)

        function callback(data) {
            console.log(data);
            if (next) {
                activityRef.current = {
                ...activityRef.current,
                ...data
                };
            } else {
                activityRef.current = {...data};
            }
            if (Object.keys(data).length < moreLimit) {
                setNoMore(true);
            } else {
                setNoMore(false);
            }
            setActivityToDisplay(activityRef.current);
        }
    }
        // console.log('getXpEarningsList', playerData, lastTs);
        // getGameActivityFromDb({
        //     "gameId": playerData.gameId,
        //     "playerId": playerData.playerId,
        //     "elementId": 'xp',
        //     "limit": limit,
        //     "lastTs": lastTs,
        //     "once": true,
        //     "callback": callback,
        // })
        // function callback(data) {
        //     dataRef.current = {
        //         ...dataRef.current,
        //         ...data
        //     }
        //     console.log(data);
        //     setSortedList(Object.values(dataRef.current));
        //     setLoading(false);
        // }
    // }

    // function loadMore() {
    //     let tempData = {...dataRef.current};
    //     let lastTs = new Date().getTime();
    //     if (Object.values(tempData).length > 0) {
    //         const lastItem = Object.values(tempData).sort((a, b) => a.ts - b.ts)[0];
    //         console.log(lastItem);
    //         lastTs = lastItem.ts;
    //     }
    //     setLastTs(lastTs);
    //     setMoreCount(moreCount + 1);
    // }

    return (
        <div className='xp-earnings-list'>
            <div className='g-card list-card'>
                <BackButton cancel={() => navigate(-1)} />
                <div>
                    <div className='card-title split'>
                        XP Earnings
                        {
                            (location.pathname.includes('/manage/')) &&
                            <PlayerNameIcon player={playerData} />
                        }
                    </div>
                    <div className='g-space-1'></div>
                    <hr className='no-margin'/>
                    <div className='g-space-0-5'></div>
                    {
                        (playerData) &&
                        <div className='summary meta'>
                            <div className='info'>
                                Total XP Earned: 
                                <ImageContainer src='/images/xp.png' className='summary-icon' />
                                <b>{playerData.points.toLocaleString()}</b>
                            </div>
                        </div>
                    }
                </div>
                {
                    (gameData && playerData && gameElements) && 
                    <PlayerEarningsList
                        gameData={gameData}
                        playerData={playerData}
                        gameElements={gameElements}
                        type='xp' />
                }
                {/* <Routes>
                    <Route path='' element={
                        (loading)
                        ?
                        <div className='center-col'><ThreeDotsLoader /></div>
                        :
                        (Object.values(activityToDisplay).length > 0)
                        ?
                        <div></div>
                        : 
                        <h4 className='center-col'>
                            No earnings yet...
                        </h4>
                        // (sortedList)
                        // ?
                        // <div className='list-container'>
                        // {
                        // sortedList
                        // .sort((a, b) => b.ts - a.ts)
                        // .map((a, i) => {
                        //     const data = Object.values(a.data).filter(d => d.type === 'xp')[0];
                        //     return (
                        //         <div key={a.ts} className='g-list-item xp-item'>
                        //             <ImageContainer src={a.icon} className='icon' />
                        //             <div className='info'>
                        //                 <div className='title'>
                        //                     <ImageContainer src='/images/xp.png' />
                        //                     {data.title}
                        //                 </div>
                        //                 <div className='meta'>
                        //                     {a.event}<br />
                        //                     {format(new Date(a.ts), "Pp")}
                        //                 </div>
                        //             </div>
                        //             {
                        //                 (a.type === 'secretCode' && a.info)
                        //                 ?
                        //                 <div className='comment'>
                        //                     Info:<br /><b>{a.info}</b>
                        //                 </div>
                        //                 :
                        //                 (a.comments)
                        //                 ?
                        //                 <div className='comment'>
                        //                     Comments:<br /><b>"{a.comments}"</b>
                        //                 </div>
                        //                 :
                        //                 (a.info)
                        //                 ?
                        //                 <div className='comment'>
                        //                     Info:<br /><b>{a.info}</b>
                        //                 </div>
                        //                 :
                        //                 null
                        //             }
                        //         </div>
                        //     )
                        // })
                        // }
                        // {
                        //     <div className='load-more center-col'>
                        //         <button 
                        //             className={`g-button med-btn ${
                        //                 moreCount * limit > sortedList.length ? 'disabled' : ''
                        //             }`} 
                        //             onClick={loadMore}>
                        //             Load More
                        //         </button>
                        //     </div>
                        // }
                        // </div>
                    }></Route>
                    <Route path=':transPath' element={
                        <div className='transaction-container'>
                            <div className='transaction-card g-card'>
                                {
                                    (playerData) &&
                                    <TransactionView
                                    activityToDisplay={activityToDisplay}
                                    playerList={{[playerData.playerId]: playerData}}
                                    gameElements={gameElements}
                                    gameManagers={[]} />
                                }
                            </div>
                        </div>
                    }></Route>
                </Routes> */}
            </div>
            <div className="g-space-2"></div>
        </div>
    )
}

export default MyXpEarningsList